import * as React from 'react'
import DeliveryDay from './delivery-day'
import { useAppSelector } from '../../../redux/hooks';

export default function InqueryPrice(props: any) {

  const {i18n, sampleInfo, quantity, price, moq, trade, type} = props;

  const skuInfo = useAppSelector(state => state.sku[type]);
  const {totalPrice} = skuInfo;

  const {formatPrice, maxQuantity} = sampleInfo;

  const {unit, unitEven, currencyRule: {
    currencyPattern,
    maximumFractionDigits,
   }} = price;

  return (
    <div className="express-item">
         <div className="item-tips">
           {i18n["pc.details.sample.dialog.max.unit"].replace('{0}', maxQuantity)}</div>
         <div className="item-left">
           {quantity === 0 ? <span className="ext">0/1 {unit}</span> : <span className="ext">{quantity} {unitEven}</span>}
         </div>
         <div className="item-right">
           <span className="normal">{i18n["202107_detail_pc_ShippingFloor_LowestPrice"]}</span>
           <span className="price">{quantity > 0 ? currencyPattern.replace( "{0}", totalPrice.toFixed( maximumFractionDigits ) ) : formatPrice}
           </span>
         </div>
         <DeliveryDay i18n={i18n} moq={moq} quantity={quantity} ladderPeriodList={trade?.leadTimeInfo?.ladderPeriodList} />
       </div>
  )
}
